import * as types from './types';

export default {
  [types.SET_UNREAD_COUNT]: (state, unreadCount) => {
    state.unreadCount = unreadCount;
  },

  [types.SET_EMPLOYEE_ROOMS]: (state, employeeRooms) => {
    state.employeeRoomList = employeeRooms;
  },

  [types.SET_EMPLOYEE_ROOMS_WITH_OWNERS]: (state, employeeRooms) => {
    state.employeeRoomListWithOwners = employeeRooms;
  },

  [types.SET_EMPLOYEE_ROOMS_WITH_TENANTS]: (state, employeeRooms) => {
    state.employeeRoomListWithTenants = employeeRooms;
  },

  [types.SET_EMPLOYEE_ROOMS_WITH_OTHER_CLIENTS]: (state, employeeRooms) => {
    state.employeeRoomListWithOtherClients = employeeRooms;
  },

  [types.SET_CLIENT_ROOM]: (state, clientRoomId) => {
    state.clientRoomId = clientRoomId;
  },

  [types.SET_PARTICIPANTS]: (state, participants) => {
    state.participants = participants;
  },

  [types.SET_SELECTED_CHAT]: (state, chat) => {
    state.selectedChat = chat;
  },
};
